<template>
  <div class="submenu" :class="{ '--collapsed': innerIsCollapsed }">
    <div class="submenu__content" @click="toggleCollapsed">
      <Icon class="submenu__icon" name="arrow-bottom" size="small" />
      <div class="submenu__title">
        {{ title }}
      </div>
      <span
        v-if="isOnlineReception"
        id="js-questionnaire-unread-badge"
        class="clinic-sidebar__list-item-balloon-num clinic-sidebar__list-item-balloon"
        :class="{ 'd-none': notificationUnreadCount <= 0 }"
        >{{ notificationUnreadCount }}</span
      >
    </div>
    <transition
      name="accordion"
      @before-enter="beforeEnter"
      @enter="enter"
      @before-leave="beforeLeave"
      @leave="leave"
    >
      <div v-if="!innerIsCollapsed" class="submenu__body">
        <slot name="body" />
      </div>
    </transition>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import Icon from '@/components/clinic/shared/icon/index.vue';
import { nextFrame } from '@/utility/animation';
const { mapActions } = createNamespacedHelpers('questionnaire');

export default {
  components: {
    Icon,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    isCollapsed: {
      type: Boolean,
      default: false,
    },
    isOnlineReception: {
      type: Boolean,
      default: false,
    },
    initUnreadCount: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      innerIsCollapsed: false,
      notificationUnreadCount: this.initUnreadCount,
    };
  },
  watch: {
    isCollapsed: {
      handler(value) {
        this.innerIsCollapsed = value;
      },
      immediate: true,
    },
  },
  mounted() {
    if (this.isOnlineReception) {
      window.addEventListener('message', (e) => {
        this.receiveNotificationUnreadCount(e);
      });
    }
  },
  beforeDestroy() {
    if (this.isOnlineReception) {
      window.removeEventListener('message', (e) => {
        this.receiveNotificationUnreadCount(e);
      });
    }
  },
  methods: {
    ...mapActions(['fetchNotificationUnreadCountCacheClear']),
    receiveNotificationUnreadCount(e) {
      if (e.data.action === 'postNotificationUnreadCount') {
        this.notificationUnreadCount = e.data.message;
        this.fetchNotificationUnreadCountCacheClear();
      }
    },
    toggleCollapsed() {
      this.innerIsCollapsed = !this.innerIsCollapsed;
    },
    beforeEnter(el) {
      el.style.height = '0';
    },
    enter(el) {
      nextFrame(() => {
        el.style.height = `${el.scrollHeight}px`;
      });
    },
    beforeLeave(el) {
      el.style.height = `${el.scrollHeight}px`;
    },
    leave(el) {
      nextFrame(() => {
        el.style.height = '0';
      });
    },
  },
};
</script>

<style lang="sass" scoped>
@import @assets/stylesheets/clinic/_mixin.sass

// TODO: variablesで管理する
$selected: rgba(255,255,255,0.2)

.submenu
  font-size: 1rem
  position: relative
  list-style: none
  align-items: center
  cursor: pointer

  &__title
    padding-left: 24px

  &__content
    display: flex
    align-items: center
    justify-content: flex-start
    width: 100%
    position: relative
    padding: 16px 20px

    &:hover
      color: white
      background: $selected

  &__icon
    position: absolute
    transform: rotate(180deg)
    transition: transform .5s

    .--collapsed &
      transform: rotate(0deg)

  &__body
    overflow: hidden
    transition: height 0.5s
</style>
